import React from "react";
import { useUser } from "src/shared/context/UserContext";
import ThermalPrinter1 from "./ThermalPrinter1";
import ThermalPrinter2 from "./ThermalPrinter2";
import ThermalPrint3 from "./ThermalPrint3";
import { ProductNote, ReturnItem } from "src/shared/services/interface";
import PrintAppFind from "./PrintAppFind";
import PrintSection from "src/shared/configurations/commonPrint/html/PrintSection";

export const formatTerms = (text: string) => {
  if (!text) return "";
  return text.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>");
};

export interface PrintData {
  CustomerName: string;
  CustomerPhon: string;
  OrderId: string;
  OrderStatus: string;
  discount: number;
  deliveryFee?: number;
  Date: string;
  returnAmount?: number;
  changeAmount?: number;
  balance?: number;
  Time: string;
  parcelFee?: number;
  tip?: string | number;
  Products?: Array<{
    productName: string;
    arabicword?: string;
    amount: number;
    quantity: number;
    totalPrice: number;
    uom?: string;
    addOns?: ProductNote[];
    barcodeId?: any;
  }>;
  returnProducts?: ReturnItem[];
  deliveryType?: string;
  sellerName?: string;
  Paid: number;
  unpaid: number;
  Tip?: string | number;
  OSB?: string | number;
  paymentMethod?: string;
  total: string | number;
  subtotal: number;
  imglogo?: any;
  businessLocation?: string;
  clientId?: string;
  billNo?: number;
  prvPaid?: number;
  prvBalance?: number;
  prvAvabile?: boolean;
  payMentHistory?: Array<{
    Paymentmethod: string;
    ReceivedAmount: number;
    date: string;
    payment_on: string;
    balance: number;
    paidAmount: number;
    balanceReturned?: number;
    adjustAmount?: number;
    refundAmount?: number;
  }>;
  payMentHistoryAvabile?: boolean;
  businessType?: string;
  resvedAmount?: number;
  balanceReturned?: number;
  balanceEnabiled?: boolean;
  createdBy?: string;
}

export interface ledgerPaid {
  Balance: number;
  Paid: number;
  PreviousBalance?: number;
  previousLabel?: string;
  paidLabel?: string;
  balanceLabel?: string;
  isAdvance?: boolean;
  clientId: string;
  CustomerPhon: number;
  CustomerName: string;
  Time: string;
  Date: string;
  paymentMethod: string;
  billNo: number;
  discount?: number;
  createdBy?: string;
}

export interface ThermalPrinterTestProps {
  PrintData?: PrintData;
  BtnName?: string;
  openPrint?: string;
  paymentMethod?: string;
  username?: string;
  isClosed?: (data: boolean) => void;
  ledgerPaid?: ledgerPaid;
  barcodeTrue?: boolean;
  icon?: any;
  className?: string;
  handleAppPrint?: (data: any) => void;
  disabled?: boolean;
  onBeforePrint?: () => void;
  onAfterPrint?: () => void;
  printerCheck?: string;
  refundPrint?: RefundData;
}
interface RefundData {
  orderId: string;
  refundAmount: number;
  // refundType: RefundType;
}

export const LABELS = {
  orderId: "Order ID (رقم الطلب)",
  billNo: "Bill No (رقم الفاتورة)",
  status: "Status (الحالة)",
  paymentType: "Pay. Type (طريقة الدفع)",
  date: "Date (التاريخ)",
  time: "Time (الوقت)",
  sellerName: "Seller Name (اسم البائع)",
  deliveryType: "Delivery Type (نوع التوصيل)",

  customerName: "Cus. Name (اسم العميل)",
  customerPhone: "Cus. Phone (رقم الهاتف)",
  clientId: "Client ID (رقم العميل)",

  productName: "Product Name <br/> اسم المنتج",
  quantity: "Qty <br/> الكمية",
  price: "Price <br/> السعر <br/> (ر.ق)",
  total: "Total  الإجمالي <br/> (ر.ق)",

  subtotal: "Subtotal (المجموع الفرعي)",
  discount: "Discount (الخصم)",
  deliveryFee: "Delivery Fee (رسوم التوصيل)",
  paid: "Paid (المدفوع)",
  due: "Due (المتبقي)",
  outstanding: "Outstanding (الرصيد المستحق)",
  total2: "Total  (الإجمالي)",

  paymentHistory: "Payment History (سجل المدفوعات)",
  paymentMethod: "Method (الطريقة)",
  received: "Received (المستلم)",
  balance: "Balance (الرصيد)",
};

function PrintConfigration(props: ThermalPrinterTestProps) {
  const { userConfigration, user } = useUser();
  const toBoolean = (value: any) => value === true || value === "true";

  const appPrinterEnabled = toBoolean(userConfigration?.appPrinterEnabled);

  // ✅ Only call PrintAppFind if enabled
  const { handlePrint } = PrintAppFind();

  const printPage = userConfigration?.printType;

  const checkPrinter = user?.businessType === "Grocery" ? (printPage === "print:1" ? "print:2" : printPage) : printPage

  const AppPrint = `<!DOCTYPE html>
      <html>
        <head>
          <style>
            * {
              font-size: 12px;
              box-sizing: border-box;
            }

            /* 🔥 Use 76mm instead of 80mm for safe printable area */
            html, body {
              width: 73mm;
              margin: 0;
              padding: 3px; /* Add some padding to prevent content from being cut off */
            }

            /* 🔥 Important for Puppeteer */
            @page {
              size: 73mm auto;
              margin: 0;
            }

            .page {
              width: 73mm;
              margin: 0;
              padding: 4px; /* Add some padding to prevent content from being cut off */
            }

            .receipt-content {
              width: 100%;
              padding: 4px;
              font-family: Arial, sans-serif;
            }

            /* ---------- TABLE ---------- */

            table {
              width: 100%;
              border-collapse: collapse;
              table-layout: fixed; /* Prevents overflow */
            }

            th, td {
              padding: 3px 2px;
              font-size: 12px;
              overflow: hidden;
            }

            /* Column Width Distribution (Safe for 76mm) */
            .col-no    { width: 6%;  text-align: left; }
            .col-name  { width: 38%; word-break: break-word; }
            .col-qty   { width: 12%; text-align: center; }
            .col-price { width: 22%; text-align: right; }
            .col-total { width: 22%; text-align: right; }

            /* Allow only product name to wrap */
            .col-name {
              white-space: normal;
            }

            /* Keep numbers in one line */
            .col-price,
            .col-total,
            .col-qty {
              white-space: nowrap;
            }

            /* Optional copy break */
            .copy-break {
              page-break-after: always;
            }
              div, p, table, tr, td, img {
              page-break-inside: avoid;
              break-inside: avoid;
            }

            body {
              page-break-after: avoid;
            }
              .copy-break {
              page-break-after: always;
            }
      </style>
    </head>`;

  const SystemPrint = `<!DOCTYPE html>
  <html>
    <head>
      <style>
        * {
          font-size: 12px;
          margin: 1;
          box-sizing: border-box;
        }

        body {
          margin: 0;
          padding: 0;
        }

        @page {
          size: auto;
          margin: 5mm;
        }

        .page {
          width: auto !important;
          margin: 0;
          padding: 0;
        }
            .col-price,
            .col-total,
            .col-qty {
              white-space: nowrap;
            }

        .receipt-content {
          width: 80%;
          padding: 5px;
        }

        div, p, table, tr, td, img {
              page-break-inside: avoid;
              break-inside: avoid;
            }

        body {
              page-break-after: avoid;
            }
        /* Important for 2 copy printing */
            .copy-break {
              page-break-after: always;
            }
      </style>
    </head>
    `;

  const printerCheck = appPrinterEnabled ? AppPrint : SystemPrint;

  const isLedgerPrint = Boolean(props.ledgerPaid);

  return (
    <>
          {checkPrinter === "print:1" && <ThermalPrinter1 {...props} />}
          {checkPrinter === "print:2" && <ThermalPrinter2 {...props} printerCheck={printerCheck} handleAppPrint={(data) => handlePrint(data)} />}
          {checkPrinter === "print:3" && <ThermalPrint3 {...props} handleAppPrint={(data) => handlePrint(data)} printerCheck={printerCheck} />}
        </>
    // <>
    //   {userConfigration?.customEnabledPrint ? (
    //     <PrintSection
    //       BtnName={props.BtnName}
    //       printData={props.PrintData}
    //       ledgerPaid={props.ledgerPaid}
    //       ledgerPaidAvabile={isLedgerPrint}
    //       openPrint={props.openPrint}
    //     />
    //   ) : (
    //     <>
    //       {printPage === "print:1" && <ThermalPrinter1 {...props} />}
    //       {printPage === "print:2" && <ThermalPrinter2 {...props} printerCheck={printerCheck} handleAppPrint={(data) => handlePrint(data)} />}
    //       {printPage === "print:3" && <ThermalPrint3 {...props} handleAppPrint={(data) => handlePrint(data)} printerCheck={printerCheck} />}
    //     </>
    //   )}
    // </>
  );
}

export default PrintConfigration;
